import React from 'react'
import simg1 from './images/strategy_dummy1.jpg'
import simg2 from './images/strategy_dummy2.jpg'

export default function Stratergy_img_section() {
  return (
    <>
      <div className="container strategy-main">
        <div className="row row-cols-2 strategy-row">
            <div className="col img1-white">
                <div className="main-white-img">
                    <img src={simg2} alt="" />
                </div>
            </div>
            <div className="col img2-black">
                <div className="main-black-img">
                <img src={simg1} alt="" />
                </div>
            </div>
        </div>
      </div>
    </>
  )
}
